import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, Validators } from "@angular/forms";

@Component({
  selector: "app-popup",
  templateUrl: "./popup.component.html",
  styleUrls: ["./popup.component.sass"],
})

export class PopupComponent implements OnInit {
  
  @Input() title: string;
  @Input() message: string;
  @Input() btnTitle: string;
  @Input() viewRadioBtn: boolean = false;
  @Input() viewInput: boolean = false;
  @Input() viewCancelBtn: boolean = true;
  @Input() viewCrossBtn: boolean = true;
  @Input() viewLink: boolean = false;
  @Input() link: string = "";
  @Input() linkMessage: string = "";
  @Input() placeholder: string = "";
  @Input() pattern: RegExp = null;
  @Output() getValue = new EventEmitter();
  @Input() errorMessage: string | null = null;
  @Input() viewSalesMessage: boolean = false;
  @Input() salesMessage: string = "";
  @Input() salesLink: string = "";
  @Input() btnTitleColor:string = 'btn-primary'
  validationError: string = "";
  
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if (this.viewInput && this.pattern != null) {
      this.onChange();
    }
  }

  selectedOption: string = "no";
  inputForm = new FormGroup({
    inputValue: new FormControl("", [Validators.required]),
  });

  private validInput(inputValue): boolean {
    this.validationError = null;
    if (this.pattern == null) return true;
    if (this.pattern.test(inputValue)) {
      return true;
    }
    this.validationError = "Invalid Input"
    return false;
  }

  onChange(): void {
    this.inputForm.valueChanges.subscribe(value => {
      if (this.validationError) {
        this.validInput(value.inputValue)
      }
    });
  }

  returnValue() {
    if (this.viewInput) {
      if (this.validInput(this.inputForm.controls.inputValue.value)) {
        this.getValue.emit(this.inputForm.controls.inputValue.value);
      }
    } else {
      this.getValue.emit(true);
    }
  }

}
